module.exports = __webpack_public_path__ + "img/6-2.71131c45.jpg";